import React from "react";

import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import PrincipalList from "../../components/PrincipalList";
import SchoolList from "../../components/SchoolList";

const Entities: React.FC = () => {
  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Schools"></CardHeader>
          <CardContent>
            <SchoolList></SchoolList>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Principals"></CardHeader>
          <CardContent>
            <PrincipalList></PrincipalList>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Entities;
